import React, { useRef, useState } from 'react';
import { Columns } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';
import { useOnScreen } from '@hooks/useOnScreen';
import {
  LeftColumn,
  StyledColumns,
  StyledRsvpText,
  StyledSection,
  StyledTypist,
  StyledTypistFieldWrapper,
  StyledTypistImageBackground,
  StyledTypistTextBox,
} from './RSVPByNameSection.styles';
import { onlineRsvpPageData } from '@data-ts/pages/online-rsvp';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import 'react-typist/dist/Typist.css';

export const RSVPByNameSection: React.FC<{}> = () => {
  const typeAheadRef = useRef<HTMLDivElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isScrolledIntoView, setScrolledIntoView] = useState(false);
  const sectionId = 'RSVP_Name_Matching';
  const onScreen = useOnScreen(typeAheadRef, '-300px 0px -200px 0px');
  const rsvpByNameData = onlineRsvpPageData.rsvpByName;
  return (
    <StyledSection backgroundColor="blue6" ref={sectionRef} id={sectionId}>
      <LazyLoadWrapper
        beforeLoad={() => {
          setScrolledIntoView(true);
        }}
      >
        <div />
      </LazyLoadWrapper>
      <StyledColumns verticalAlign={'center'}>
        <LeftColumn width={7}>
          <StyledTypistImageBackground isScrolledIntoView={isScrolledIntoView}>
            <StyledTypistFieldWrapper>
              <StyledRsvpText tagName="p" variant="calloutHed32" color="blue6" marginBottom={[2, 4]}>
                Enter your name to RSVP
              </StyledRsvpText>
              <StyledTypistTextBox ref={typeAheadRef} backgroundColor="mono7" paddingTop="20px">
                {onScreen ? (
                  <StyledTypist>
                    <span className="typistText">Carolina Ynez</span>
                  </StyledTypist>
                ) : null}
              </StyledTypistTextBox>
            </StyledTypistFieldWrapper>
          </StyledTypistImageBackground>
        </LeftColumn>
        <Columns.Column width={5}>
          <TextPairing
            style={{ maxWidth: '478px' }}
            eyebrow={rsvpByNameData.eyebrow}
            eyebrowColor="blue3"
            eyebrowVariant="sectionEyeBrow24"
            eyebrowTagName="h2"
            title={rsvpByNameData.title}
            titleMaxWidth="400px"
            titleColor="blue1"
            titleVariant="hed72Hero"
            titleTagName="h2"
            body={rsvpByNameData.content}
            bodyColor="blue1"
            bodyVariant="dek24"
            bodyMaxWidth="335px"
          />
        </Columns.Column>
      </StyledColumns>
    </StyledSection>
  );
};
